// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Russia from '../_raw/flag/icon_flag_russia.png';

export default () => <img src={Russia} alt="Russia" />;
